define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var HelpScoutConversationModel = /** @class */ (function () {
        function HelpScoutConversationModel(data) {
            this.MailboxId = ko.observable(0);
            this.ContactId = ko.observable(0);
            this.Subject = ko.observable('');
            this.Status = ko.observable('');
            this.Body = ko.observable('');
            this.OwnerId = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.Cc = ko.observable('');
            this.Bcc = ko.observable('');
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, HelpScoutConversationModel.Mapping, self);
            }
        }
        HelpScoutConversationModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new HelpScoutConversationModel(options.data);
            }
        };
        return HelpScoutConversationModel;
    }());
    return HelpScoutConversationModel;
});
//# sourceMappingURL=HelpScoutConversationModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/HelpScoutConversationModel.js
// module id = 85
// module chunks = 2